import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { I18N } from '../services/i18n.service';

/**
 * HTTP interceptor that adds the Accept-Language header to all outgoing requests
 * based on the current language setting from the I18N service.
 */
export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const i18n = inject(I18N);
  const currentLanguage = i18n.getLanguage();

  // Clone the request and add the Accept-Language header
  const modifiedReq = req.clone({
    setHeaders: {
      'Accept-Language': currentLanguage,
    },
  });

  return next(modifiedReq);
};
